export { default } from './GovernorAndProfessional';
export { default as datamap } from './GovernorAndProfessional.datamap';
export type { PageData } from './GovernorAndProfessional.datamap';
